import { FC, memo } from 'react'

import { BoardScore } from 'components/icons'
import { Tooltip, Box } from '@chakra-ui/react'

type Props = {
  hasScore?: boolean
  label?: string
}

const ScoreIcon: FC<Props> = ({ hasScore, label }) => {
  if (!hasScore) return <></>

  return (
    <Tooltip label={label}>
      <Box>
        <BoardScore color="dark" />
      </Box>
    </Tooltip>
  )
}

export default memo(ScoreIcon)
